import renderDatetime from '../../../../helpers/tables/render-datetime'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'

export const createdAtColumn: ShipmentColumn = {
    key: 'createdAt',
    dataIndex: 'createdAt',
    title: (
        <>
            Дата <br />
            создания
        </>
    ),
    width: 106,
    render: renderDatetime,
    onCell: onCellStandard,
}
